<template>
    <section>
        <div class="page">
            <div>
                <h2>Notifications are not working</h2>
                <p>
                    When a message is sent to you via ToTok, but you do not have the app open to receive it, your phone
                    will
                    automatically display a push notification to alert you of the message. Android apps can provide
                    three types of
                    notifications:
                </p>
                <ul>
                    <li>
                        Sounds: An audible alert plays.
                    </li>
                    <li>
                        Alerts/Banners: An alert or banner appears on the screen.
                    </li>
                    <li>
                        Badges: An image or number appears on the application icon.
                    </li>
                </ul>
                <h3>
                    Setting up notifications
                </h3>
                <p>
                    Please verify that your notification settings are turned on in both your ToTok and phone settings:
                </p>
                <ul>
                    <li>
                        Go to <strong>ToTok > Me > Settings > Notifications</strong> and check that Notifications are
                        enabled for
                        Messages, Groups, and
                        Calls.
                    </li>
                    <li>You can turn off the vibration or sounds you experience in the app, for example the sounds you
                        hear when you
                        send or receive messages. Go to <strong> Me > Settings >Notifications > In-App
                            Notification</strong>.
                    </li>
                    <li>Go to phone <strong>Settings > Sounds > ToTok</strong>. Set your preferences for Alert style
                        (Banners, Pop-up
                        alert, or None),
                        Badges, and Sounds. If you want notifications to appear when your phone's display is off, enable
                        Show on Lock
                        Screen.
                    </li>
                    <ul>
                        <li>
                            The alert sound volume is controlled by your phone's ringer volume, which can be set in
                            phone<strong> Settings
                            >
                            Sounds</strong>.
                            Here, you can also set your Vibrate preferences.
                        </li>
                    </ul>
                </ul>
                <h3>Notification problems</h3>
                <p>To ensure the prompt delivery of ToTok messages and notifications, your phone must be configured
                    properly.
                </p>
                <p>Make sure your phone has Internet connection. You can check this by opening a browser and going to a
                    website.
                </p>
                <p>If browsing works, but ToTok doesn't, please contact your mobile provider and system administrator
                    and make
                    sure that your APN and router are configured correctly to allow non-web and socket connections. You
                    may also try
                    a different connection. If you are connected to Wi-Fi, try mobile data or vice versa.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
